import { render } from "./PurchaseReceiveList.vue?vue&type=template&id=c9fdf366"
import script from "./PurchaseReceiveList.vue?vue&type=script&lang=js"
export * from "./PurchaseReceiveList.vue?vue&type=script&lang=js"

import "./PurchaseReceiveList.vue?vue&type=style&index=0&id=c9fdf366&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__